// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .length-column {
  position: sticky !important;
  left: 0;
}
.presize-root .selectable-cell .selectable-cell-form {
  margin: 0;
  text-align: center;
}
/*# sourceMappingURL=SelectableCell.css.map */`, "",{"version":3,"sources":["webpack://./SelectableCell.less","webpack://./src/components/Matrices/SelectableMatrix/SelectableCell/SelectableCell.less"],"names":[],"mappings":"AAAA;EAEE,2BAAA;EACA,OAAA;ACAF;ADHA;EAOI,SAAA;EACA,kBAAA;ACDJ;AACA,6CAA6C","sourcesContent":[".presize-root { \n .length-column {\n  position: sticky !important;\n  left: 0;\n}\n.selectable-cell {\n  .selectable-cell-form {\n    margin: 0;\n    text-align: center;\n  }\n}\n \n}",".presize-root .length-column {\n  position: sticky !important;\n  left: 0;\n}\n.presize-root .selectable-cell .selectable-cell-form {\n  margin: 0;\n  text-align: center;\n}\n/*# sourceMappingURL=SelectableCell.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
